import styled from 'styled-components';

export const StyledProjectSection = styled.section`
    padding: 12rem 0;
    
@media (max-width: 56.25em){
    padding: 4rem 0;
}
`
